/** Section id wrapping the lead / B2B / roadmap forms (see pages). */
export const JOIN_SECTION_ID = "join";

export function scrollToJoinSection(): boolean {
  const el = document.getElementById(JOIN_SECTION_ID);
  if (!el) return false;
  el.scrollIntoView({ behavior: "smooth", block: "center" });
  return true;
}
